import { Button } from "@Light/components/page/Button";
import { ButtonFooter } from "@Light/components/page/ButtonFooter";
import React from "react";
import { useIsSubtleBrand, useScaffold } from "../../scaffold";

export type BackToPlatformProps = {
  appUrl: string;
};

export const BackToPlatform: React.FC<BackToPlatformProps> = ({ appUrl }) => {
  const scaffold = useScaffold();
  const isSubtle = useIsSubtleBrand();
  const PageBody = scaffold.page.pageBody;
  const Title = scaffold.page.title;
  const Subtitle = scaffold.page.subtitle;

  const handleBackToPlatform = () => {
    window.location.href = appUrl;
  };

  return (
    <PageBody
      footer={
        <ButtonFooter>
          <Button size="lg" className="w-full" onClick={handleBackToPlatform}>
            {isSubtle
              ? "Exit"
              : `Go to the ${scaffold.page.companyName} platform`}
          </Button>
        </ButtonFooter>
      }
    >
      <div className="absolute top-1/2 left-0 w-full -translate-y-1/2 px-4 gap-4 flex flex-col text-center">
        <div className="flex flex-col gap-2">
          <Title>You're all set</Title>
          <Subtitle>
            {isSubtle
              ? "You can now exit or close this window."
              : `You can now return to the ${scaffold.page.companyName} platform or close this window.`}
          </Subtitle>
        </div>
      </div>
    </PageBody>
  );
};
